
/**
 * Support Request Status Enum
 */
export const SUPPORT_REQUEST_STATUS = {
    MESSAGED: 'messaged', // Initial state
    VIEWED: 'viewed',
    RESOLVED: 'resolved',
};

/**
 * Support Request Schema
 */
export const supportRequestSchema = {
    createdAt: { _value: '', _immutable: true }, // ISO Date string
    updatedAt: '', // ISO Date string
    userId: { _value: '', _immutable: true, _rule: 'this.size() > 0' },
    userType: { _value: '', _immutable: true, _enum: ['employer', 'professional'] },
    relatedId: { _value: '', _optional: true }, // Job ID or Application ID
    relatedType: { _value: '', _optional: true, _enum: ['job', 'application'] },
    msg: { _value: '', _rule: 'this.size() > 0' }, // The user's query/issue
    status: { _value: SUPPORT_REQUEST_STATUS.MESSAGED, _enum: Object.values(SUPPORT_REQUEST_STATUS) },
    userPhoneNumber: { _value: '', _optional: true }, // Snapshot for immediate contact
    userName: { _value: '', _optional: true }, // Name for easier display
};

/**
 * Create a support request document
 * @param {Object} params
 * @returns {Object} Support Request document
 */
export const createSupportRequestDocument = ({
    userId,
    userType,
    relatedId = '',
    relatedType = '',
    msg,
    userPhoneNumber = '',
    userName = '',
}) => {
    const timestamp = new Date().toISOString();

    return {
        createdAt: timestamp,
        updatedAt: timestamp,
        userId,
        userType,
        relatedId,
        relatedType,
        msg,
        status: SUPPORT_REQUEST_STATUS.MESSAGED,
        userPhoneNumber,
        userName,
    };
};
